define('views/modules/calendar/animated-session/animated-session-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/events/calendar-events',
    'services/events/animated-session-events',
    'services/events/layout-menu-events',
    // views
    'views/modules/calendar/calendar-item-panel',
    // views content
    'views/modules/calendar/animated-session/session/session-edit-content',
    'views/modules/calendar/favorite/favorite-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    CalendarEvents,
    AnimationEvents,
    LayoutMenuEvents,
    // views
    VCalendarItemPanel,
    // views content
    VSessionEditContent,
    VFavoriteContent
) {

    var VAnimatedSessionPanel = VCalendarItemPanel.extend({
        header: {
            title: "calendar:Animated Session",
            subtitle: "calendar:Create/Modify your animated session",
        },

        tabs: function() {
            var tabs = [
                { id: 'details', title: 'Details', active: true, callback: 'showDetails' },
                { id: 'favorite', title: 'Favorite', callback: 'showFavorite' }
            ];
            var tabsFiltered = _.reject(tabs, function(tab) {
                return tab.id === 'favorite' && this.options.role === 'client';
            }, this);

            if (tabsFiltered.length < 2) return tabsFiltered;
            if (tabsFiltered.length < 4) {
                tabsFiltered.push({ id: 'empty', empty: true });
                tabsFiltered.push({ id: 'empty2', empty: true });
            }

            return tabsFiltered;
        },

        content: {
            details: VSessionEditContent,
            favorite: VFavoriteContent,
        },
        defaultView: 'details',

        initialize: function(opt) {
            this.listenTo(CalendarEvents, { 'session:destroy': this.onSessionDestroy })
                .listenTo(this.model, { 'sync': this.onModelSync });

        },

        getContentViewOptions: function(opt) {
            return _.extend({
                model: this.model,
            }, _.pick(this.options, [
                'group',
                'profile',
                'url',
                'role'
            ]), opt);
        },

        //////////
        // Tabs //
        //////////

        showDetails: function() {
            VAnimatedSessionPanel.__super__.showDetails.apply(this, arguments);
            AnimationEvents.refreshPanel();
        },

        showFavorite: function() {
            this.showContent('favorite', {
                type: "animated-session",
                model: this.view.details.model
            });

            AnimationEvents.refreshPanel();
        },

        ////////////
        // events //
        ////////////
        onOpen: function(open) {
            var details = this.view.details;
            if (this.is(details) && !Viewport.isMobile() && open) {
                // if there's no exercises yet, show the search panel.
                details.toggleAnimationPanel(true);
            }
            this.listenTo(LayoutMenuEvents, { 'item:click': this.onMenuClick });
        },

        onSync: function() {

        },

        onSessionDestroy: function(id) {
            if (this.model.is(id)) this.close();
        },

        // onExpandPanel: function() {
        //     if (LayoutState.isFull('info')) {
        //         LayoutState.toggleInfoFull();
        //     } else {
        //         this.view.details.toggleAnimationPanel(true);
        //     }
        // },

        onSuccess: function() {
            this.close();
            this.stopListeningTo(LayoutMenuEvents, 'item:click');
        },

        onMenuClick: function() {
            this.close();
            this.stopListeningTo(LayoutMenuEvents, 'item:click');
        },

        onModelSync: function(model) {
            this.view.layout.setTitle(model.getName());
        },

    });

    return VAnimatedSessionPanel;
});

